import { Injectable } from '@angular/core';
import { ApiModel } from '../model/api';
import { HttpClient } from '@angular/common/http';
import { URL_PORTAL_SERVICOS_API } from "../util/constants";
import { StorageService } from './storage.service';

@Injectable()
export class ApiService {

  apis: ApiModel[];

  constructor(
    private storageSercice: StorageService,
    private http: HttpClient
  ) {
    this.loadApis();
  }

  async loadApis(): Promise<ApiModel[]> {
    return this.apis = (<any>await this.http.get('/assets/data/apis.json').toPromise()).apis;
  }

  async buscarPorId(id: number): Promise<ApiModel> {
    return (this.apis || await this.loadApis()).find(api => api.id.toString() === id.toString());
  }

  buscarPorIdSync(id: number): ApiModel {
    return this.apis.find(api => api.id.toString() === id.toString());
  }

  async buscarPorSiglaSync(nome: string) {
    return await this.apis.find(api => api.nome.toString().toLowerCase() === nome.toString().toLowerCase());
  }

  getStates() {
    return this.http.get(URL_PORTAL_SERVICOS_API + '/uf/', {}).toPromise();
  }

  getMunicipio(state) {
    return this.http.get(URL_PORTAL_SERVICOS_API + '/municipio/?codigoUf=' + state.codigo, {}).toPromise();

  }

  arquivo(hash) {
    const token = this.storageSercice.getTokenBarramento();
    const tokenBc = this.storageSercice.getTokenBc();
    const header = {
      headers: {
        'Authorization': token,
        'AuthorizationSerpro': tokenBc,
      }
    };
    return this.http.get(URL_PORTAL_SERVICOS_API + '/arquivo-imunizacao/arquivos/' + hash, header).toPromise();
  }

  async getServicoEsusve() {
    return (<any>await this.http.get('/assets/data/servicos_esusve.json').toPromise()).servicos;
  }

  async getServicoNotifica() {
    return (<any>await this.http.get('/assets/data/SERVICOS_NOTIFICA_FULL.json').toPromise()).servicos;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts